// extracted by mini-css-extract-plugin
export default {"wrapper":"PageLayout_wrapper__mEdK5","content":"PageLayout_content__jVz6I","contentInner":"PageLayout_contentInner__vg4KZ"};